<template>
  <el-form
    ref="baseForm"
    :model="model"
    :rules="rules && emptyCheck ? formatRules(rules) : rules"
    size="small"
    :label-position="labelPosition"
    :label-width="labelWidth"
    :disabled="disabled"
    v-loading="loading"
    :element-loading-text="$t('tips.loading')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="#2a2d365e"
    :class="'-gc-base-form-label--' + labelPosition"
  >
    <slot></slot>
  </el-form>
</template>

<script>
import { formatRules } from '@/utils/validate'
export default {
  props: {
    model: {
      type: Object
    },
    rules: {
      type: Object
    },
    // 不能全为空
    emptyCheck: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    labelPosition: {
      type: String,
      default: 'top'
    },
    labelWidth: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  components: {},
  mounted() {},
  methods: {
    formatRules
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/baseForm.vue